<template>
  <div class="purpose ct">
    <div class="title">
      <span>我们的服务</span>
      <span>Our Services</span>
    </div>
    <div class="pur_main">
      <div class="item" v-for="(item, index) in purpose" :key="index">
        <div class="item_img">
          <img :src="item.img" alt="" />
        </div>
        <div class="item_content">
          <span>{{ item.title }}</span>
          <span>{{ item.title2 }}</span>
          <p>{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      purpose: [
        {
          img: "https://s2.ax1x.com/2019/10/31/KoEgAK.jpg",
          title: "安卓APP开发",
          content: "原生安卓开发，开发种类有:工具类，信息类，教育类应用等！"
        },
        {
          img: "https://s2.ax1x.com/2019/10/31/KoVnD1.jpg",
          title: "小程序开发",
          content: "微信小程序，抖音小程序，微信公众号，快速开发，生态共享！"
        },
        {
          img: "https://s2.ax1x.com/2019/10/31/Komqqs.jpg",
          title: "ios开发",
          content: "ios开发，开发种类有:工具类，信息类，教育类应用等！"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.purpose {
  padding-top: 88px;
  padding-bottom: 70px;

  .title {
    padding-bottom: 30px;

    span {
      display: block;
    }

    span:nth-child(1) {
      font-size: 40px;
      font-weight: 400;
    }

    span:nth-child(2) {
      font-size: 30px;
      color: #6a6a6a;
      font-weight: 0;
      font-family: monospace;
    }
  }

  .pur_main {
    display: flex;
    justify-content: space-between;

    .item {
      width: 340px;
      height: 384px;
      cursor: pointer;

      //   box-shadow: 0 0 5px 1px #eee;
      .item_img {
        padding-top: 16px;
        padding-bottom: 28px;

        img {
          display: block;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          margin: 0 auto;
        }
      }

      .item_content {
        display: flex;
        flex-direction: column;
        padding: 0 25px;

        // padding-left: 10px;
        span:nth-child(1) {
          font-size: 26px;
          color: #3f84d4;
          padding-bottom: 10px;
        }

        span:nth-child(2) {
          padding-bottom: 20px;
          color: #d7d7d7;
        }

        p {
          color: #ccc;
          font-size: 16px;
          text-align: justify;
          line-height: 25px;
          color: #000;
        }
      }
    }

    .item:hover {
      box-shadow: 0 0 5px 2px #eee;
    }
  }
}
</style>
